import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
  label: {
    type: String,
    default: undefined,
  },
  headerClass: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, {
    label: __props.label,
    "header-class": __props.headerClass,
    class: "c-expansion-item"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["label", "header-class"]))
}
}

})